
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import { UserModule } from '@/store/modules/user';
import {
  checkPermissionCompany, checkPermissionUseAndCompany
} from '@/utils/permission';
import { Type } from '@/types/permissionType';
import draggable from 'vuedraggable';
import SearchItem from './searchItem.vue';

@Component({
  name: 'SreportFormsSearch',
  components: {
    draggable,
    SearchItem
  }
})
export default class extends Vue {
  @Prop({
    type: Object,
    default: () => ({}),
  })
  private paramData!: any;
  //   @Watch("paramData", {
  //     deep: true,
  //     immediate: true
  //   })
  // getPropDataVisible(val: any) {
  //   this.setSearch()
  // }

  private yy = new Date().getFullYear();
  private mm = new Date().getMonth();
  private dd = new Date().getDate();

  private isToggle = false
  private checkList: any = []
  private searchArray: any = []
  private showSearchArray: any = []
  private formSearch: any = {
    timePeriods: [new Date(this.yy, this.mm, 1, 0, 0, 0).getTime(), new Date(this.yy, this.mm, this.dd, 0, 0, 0).getTime()],
    tasktimePeriods: '',
    taskFinishedTime: '',
    finishedTime: '',
    orderStatus: '',
    ordernumber: '',
    orderworknumber: '',
    orderType: '',
    orderWarranty: '',
    repairMan: '',
    linkman: '',
    telephone: '',
    address: '',
    customer: {},
    isBranch: '',
    deptCustomer: {},
    fault: {},
    phenomenon: {},
    deptServicer: {},
    taskStatus: '',
    engineer: {},
    costStatus: '',
    device: {},
  }
  private searchKey = ''
  private visiblePopover = false

  private isCus=true;
  private vipLev:number = 3;
  private permissionCus=false;

  created() {
    this.isCus = checkPermissionUseAndCompany(UserModule.getCompanyId, Type.StatisticsCusDiyOrder);
    this.permissionCus = checkPermissionCompany(UserModule.getCompanyId, Type.CUSTOMER_COMPANY);
    if (UserModule.getCompany && UserModule.getCompany.vip_level) {
      this.vipLev = parseInt(UserModule.getCompany.vip_level.substr(0, 1));
    } else {
      this.vipLev = 3;
    }
    this.setSearch()
  }
  private setSearch() {
    this.formSearch = {
      timePeriods: [new Date(this.yy, this.mm, 1, 0, 0, 0).getTime(), new Date(this.yy, this.mm, this.dd, 0, 0, 0).getTime()],
      tasktimePeriods: '',
      taskFinishedTime: '',
      finishedTime: '',
      orderStatus: '',
      ordernumber: '',
      orderworknumber: '',
      orderType: '',
      orderWarranty: '',
      repairMan: '',
      linkman: '',
      telephone: '',
      address: '',
      customer: {},
      isBranch: '',
      deptCustomer: {},
      fault: {},
      phenomenon: {},
      deptServicer: {},
      taskStatus: '',
      engineer: {},
      costStatus: '',
      device: {},
    }
    this.handleSearch()
    this.searchKey = 'lsjl_search' + this.$route.path;

    let index = this.searchKey.lastIndexOf('/');
    if (index > 0) {
      this.searchKey = this.searchKey.substr(0, index) + (this.paramData.type ? this.paramData.type : '');
    }
    if (localStorage.getItem(this.searchKey)) {
      let local: any = localStorage.getItem(this.searchKey);
      let localParse = JSON.parse(local);
      for (let p = 0; p < localParse.length; p++) {
        if (localParse[p].id === '1') {
          localParse[p].fields = [new Date(this.yy, this.mm, 1, 0, 0, 0).getTime(), new Date(this.yy, this.mm, this.dd, 0, 0, 0).getTime()]
        } else {
          localParse[p].fields = '';
        }
      }
      this.searchArray = localParse;
    } else {
      this.searchArray = [
        { fields: this.formSearch.timePeriods, name: '报修日期', id: '1', checked: true, show: true },
        //show: parseInt(this.paramData.type) === 17
        { fields: this.formSearch.tasktimePeriods, name: '指派日期', id: '2', checked: false, show: true},
        { fields: this.formSearch.taskFinishedTime, name: '任务完成日期', id: '3', checked: false, show: true },
        { fields: this.formSearch.finishedTime, name: '完单日期', id: '4', checked: true, show: true }, //! this.isCus
        { fields: this.formSearch.orderStatus, name: '订单状态', id: '5', checked: false, show: true }, //! this.isCus
        { fields: this.formSearch.ordernumber, name: '订单号', id: '6', checked: true, show: true }, //! this.isCus
        { fields: this.formSearch.orderworknumber, name: '工单号', id: '7', checked: false, show: checkPermissionCompany(UserModule.getCompanyId, Type.workOrderNum) }, //! this.isCus
        { fields: this.formSearch.orderType, name: '订单类型', id: '8', checked: false, show: true }, //! this.isCus
        { fields: this.formSearch.orderWarranty, name: '原厂保修', id: '9', checked: false, show: true }, //! this.isCus
        { fields: this.formSearch.repairMan, name: '申请人', id: '10', checked: true, show: true }, //! this.isCus
        { fields: this.formSearch.linkman, name: '联系人', id: '11', checked: false, show: true }, //! this.isCus
        { fields: this.formSearch.telephone, name: '联系方式', id: '12', checked: false, show: true }, //! this.isCus
        { fields: this.formSearch.address, name: '联系地址', id: '13', checked: false, show: true }, //! this.isCus
        { fields: this.formSearch.customer, name: '客户', id: '14', checked: false, show: checkPermissionCompany(UserModule.getCompanyId, Type.CUSTOMER_COMPANY) }, //! this.isCus
        { fields: this.formSearch.isBranch, name: '是否包含分公司订单', id: '15', checked: false, show: checkPermissionCompany(UserModule.getCompanyId, Type.CUSTOMER_COMPANY) },
        {
          fields: this.formSearch.deptCustomer,
          name: '报修部门',
          id: '16',
          customerCompanyId: '',
          checked: false,
          show: true
        },
        { fields: this.formSearch.fault, name: '故障类型', id: '17', checked: false, show: true }, //! this.isCus
        { fields: this.formSearch.phenomenon, name: '故障现象', id: '18', checked: false, show: true }, //! this.isCus
        { fields: this.formSearch.deptServicer, name: '服务部门', id: '19', checked: false, show: true }, //! this.isCus
        { fields: this.formSearch.taskStatus, name: '任务状态', id: '20', checked: false, show: true }, //! this.isCus
        { fields: this.formSearch.engineer, name: '工程师', id: '21', checked: false, show: true }, //! this.isCus
        { fields: this.formSearch.costStatus, name: '费用', id: '22', checked: false, show: true }, //! this.isCus
        { fields: this.formSearch.device, name: '设备', id: '23', checked: false, show: true }, //! this.isCus
      ];
    }
    // this.itemData.customer.hidden = !this.permissionCus;
    for (let m = 0; m < this.searchArray.length; m++) {
      if (this.searchArray[m].id === '14') {
        this.searchArray[m].show = this.permissionCus;
      }
      if (this.searchArray[m].id === '7') {
        this.searchArray[m].show = checkPermissionCompany(UserModule.getCompanyId, Type.workOrderNum);
      }
      if (this.searchArray[m].id === '23') {
        this.searchArray[m].show = checkPermissionCompany(UserModule.getCompanyId, Type.device);
      }
      // this.itemData.deptCustomer.hidden = false;
      if (this.searchArray[m].id === '16') {
        if (this.vipLev === 2) {
          this.searchArray[m].show = true;
        } else {
          this.searchArray[m].show = this.permissionCus;
        }
      }
      if (this.searchArray[m].id === '19') {
        //如果是自定义报表才显示 维修部门 
        this.searchArray[m].show = "/Statistics/reportForms"==this.$route.path ? true : false;
      }
    }
    this.showSearchArray = this.searchArray.filter((v: any) => {
      return v.show === true;
    });
    this.checkList = this.searchArray.filter((v: any) => {
      return v.checked === true;
    });
  }
  
  private handleSearch() {
    const params: any = {
      start_time: this.formSearch.timePeriods ? this.formSearch.timePeriods[0] / 1000 : '',
      end_time: this.formSearch.timePeriods ? this.formSearch.timePeriods[1] / 1000 : '',
      contain_branch: this.formSearch.isBranch ? '1' : '',
    };

    if (!this.isCus) {
      params.task_start_time = this.formSearch.tasktimePeriods ? this.formSearch.tasktimePeriods[0] / 1000 : '';
      params.task_end_time = this.formSearch.tasktimePeriods ? this.formSearch.tasktimePeriods[1] / 1000 : '';
      params.task_finish_start_time = this.formSearch.taskFinishedTime ? this.formSearch.taskFinishedTime[0] / 1000 : '';
      params.task_finish_end_time = this.formSearch.taskFinishedTime ? this.formSearch.taskFinishedTime[1] / 1000 : '';
      params.finish_start_time = this.formSearch.finishedTime ? this.formSearch.finishedTime[0] / 1000 : '';
      params.finish_end_time = this.formSearch.finishedTime ? this.formSearch.finishedTime[1] / 1000 : '';
      params.order_stage = this.formSearch.orderStatus;
      params.order_num = this.formSearch.ordernumber;
      params.work_order_num = this.formSearch.orderworknumber;
      params.order_type = this.formSearch.orderType;
      params.order_warranty = this.formSearch.orderWarranty;
      params.create_user_name = this.formSearch.repairMan;
      params.link_name = this.formSearch.linkman;
      params.mobile = this.formSearch.telephone;
      params.address = this.formSearch.address;
      params.customer_company_id = this.formSearch.customer.id;
      params.customer_dept_id = this.formSearch.deptCustomer.id;
      params.fault_id = this.formSearch.fault.id;
      params.fault_phenomenon_id = this.formSearch.phenomenon.id;
      params.servicer_dept_id = this.formSearch.deptServicer.id;
      params.task_state = this.formSearch.taskStatus;
      params.engineer_id = this.formSearch.engineer.id;
      params.price_state = this.formSearch.costStatus;
      if (this.formSearch.device) {
        params.device_ids = this.formSearch.device.id;
      }
    }
    this.$emit('formSearch', params);
  }

  private handleClear() {
    this.formSearch = {
      timePeriods: [new Date(this.yy, this.mm, 1, 0, 0, 0).getTime(), new Date(this.yy, this.mm, this.dd, 0, 0, 0).getTime()],
      tasktimePeriods: '',
      taskFinishedTime: '',
      finishedTime: '',
      orderStatus: '',
      ordernumber: '',
      orderworknumber: '',
      orderType: '',
      orderWarranty: '',
      repairMan: '',
      linkman: '',
      telephone: '',
      address: '',
      customer: {},
      isBranch: '',
      deptCustomer: {},
      fault: {},
      phenomenon: {},
      deptServicer: {},
      taskStatus: '',
      engineer: {},
      costStatus: '',
      device: {},
    };
    if (this.searchArray) {
      for (let v = 0; v < this.searchArray.length; v++) {
        if (this.searchArray[v].id === '1') {
          this.searchArray[v].fields = [new Date(this.yy, this.mm, 1, 0, 0, 0).getTime(), new Date(this.yy, this.mm, this.dd, 0, 0, 0).getTime()]
        } else {
          this.searchArray[v].fields = ''
        }
      }
    }
    this.handleSearch()
  }

  private orderFormReceive(val: any, keyup: any) {
    switch (val.id) {
      case '1':
        this.formSearch.timePeriods = val.fields;
        break;
      case '2':
        this.formSearch.tasktimePeriods = val.fields;
        break;
      case '3':
        this.formSearch.taskFinishedTime = val.fields;
        break;
      case '4':
        this.formSearch.finishedTime = val.fields;
        break;
      case '5':
        this.formSearch.orderStatus = val.fields;
        break;
      case '6':
        this.formSearch.ordernumber = val.fields;
        break;
      case '7':
        this.formSearch.orderworknumber = val.fields;
        break;
      case '8':
        this.formSearch.orderType = val.fields;
        break;
      case '9':
        this.formSearch.orderWarranty = val.fields;
        break;
      case '10':
        this.formSearch.repairMan = val.fields;
        break;
      case '11':
        this.formSearch.linkman = val.fields;
        break;
      case '12':
        this.formSearch.telephone = val.fields;
        break;
      case '13':
        this.formSearch.address = val.fields;
        break;
      case '14':
        this.formSearch.customer = val.fields;
        for (let i = 0; i < this.searchArray.length; i++) {
          if (this.searchArray[i].id === '16') {
            this.searchArray[i].customerCompanyId = this.formSearch.customer.id
          }
        }
        break;
      case '15':
        this.formSearch.isBranch = val.fields;
        break;
      case '16':
        this.formSearch.deptCustomer = val.fields;
        break;
      case '17':
        this.formSearch.fault = val.fields;
        break;
      case '18':
        this.formSearch.phenomenon = val.fields;
        break;
      case '19':
        this.formSearch.deptServicer = val.fields;
        break;
      case '20':
        this.formSearch.taskStatus = val.fields;
        break;
      case '21':
        this.formSearch.engineer = val.fields;
        break;
      case '22':
        this.formSearch.costStatus = val.fields;
        break;
      case '23':
        this.formSearch.device = val.fields;
        break;
    }
    if (keyup) {
      this.handleSearch();
    }
  }

  toggleHandle() {
    this.isToggle = !this.isToggle;
  }
  resetHandle() {
    if (localStorage.getItem(this.searchKey)) {
       localStorage.removeItem(this.searchKey);
    }
    this.setSearch();
  }
  confirmHandle() {
    let setItem: any = [];
    setItem = this.searchArray.filter((t: any) =>
      (!this.checkList.some((ele: any) => ele.id === t.id)) && t.show
    );
    for (let m = 0; m < this.searchArray.length; m++) {
      for (let i = 0; i < setItem.length; i++) {
        if (this.searchArray[m].id === setItem[i].id) {
          this.searchArray[m].checked = false; // 设置取消
        }
      }
    }
    for (let m = 0; m < this.searchArray.length; m++) {
      for (let i = 0; i < this.checkList.length; i++) {
        if (this.searchArray[m].id === this.checkList[i].id) {
          this.searchArray[m].checked = true; // 设置选中
        }
      }
    }
    this.settingLocal();
    this.visiblePopover = false;
  }

  settingLocal() {
    localStorage.setItem(this.searchKey, JSON.stringify(this.searchArray));
  }
}
